// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3490":"css/modules/frontend","3901":"css/modules/administrator","5933":"css/circlecreative","7012":"css/modules/task","7907":"css/modules/client","8035":"css/modules/chat","9197":"css/modules/personal","9203":"css/modules/salesmarketing","9514":"css/modules/schedule","9632":"css/modules/finance"}[chunkId] + ".css";
};